import EstablishmentMutationProvider from '@establishment/contexts/establishmentMutationContext';
import EstablishmentEditForm from './EstablishmentEditForm';

const EditEstablishmentPage = () => {
  return (
    <EstablishmentMutationProvider>
      <EstablishmentEditForm />
    </EstablishmentMutationProvider>
  );
};

export default EditEstablishmentPage;
